import React, { useEffect, useState } from "react";
import BadgePopup from "./badge";
import { useCheckBadgesAwardMutation } from "../store/General/generalSlice";

const Achivement1 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/1.svg";
const Achivement2 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/2.svg";
const Achivement3 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/3.svg";
const Achivement4 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/4.svg";
const Achivement5 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/5.svg";
const Achivement6 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/6.svg";
const Achivement7 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/7.svg";
const Achivement8 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/8.svg";
const Achivement9 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/9.svg";
const Achivement10 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/10.svg";
const GapLine =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/line.svg";

const userIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";
export default function AchievementsRow({ UserScore, userImage }) {
  const [checkBadgesAward, { data: newBadgesData, error }] =
    useCheckBadgesAwardMutation();
  const [newBadges, setNewBadges] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const achievements = [
    {
      scoreThreshold: 50,
      imgSrc: Achivement1,
      alt: "Achievement 1",
      title: "Novice",
    },
    {
      scoreThreshold: 100,
      imgSrc: Achivement2,
      alt: "Achievement 2",
      title: "Apprentice",
    },
    {
      scoreThreshold: 250,
      imgSrc: Achivement3,
      alt: "Achievement 3",
      title: "MedExpert",
    },
    {
      scoreThreshold: 500,
      imgSrc: Achivement4,
      alt: "Achievement 4",
      title: "Scholar",
    },
    {
      scoreThreshold: 1000,
      imgSrc: Achivement5,
      alt: "Achievement 5",
      title: "Master Blaster",
    },
    {
      scoreThreshold: 1250,
      imgSrc: Achivement6,
      alt: "Achievement 6",
      title: "Disease Conqueror",
    },
    {
      scoreThreshold: 1500,
      imgSrc: Achivement7,
      alt: "Achievement 7",
      title: "Hero",
    },
    {
      scoreThreshold: 1750,
      imgSrc: Achivement8,
      alt: "Achievement 8",
      title: "Wizard",
    },
    {
      scoreThreshold: 2000,
      imgSrc: Achivement9,
      alt: "Achievement 9",
      title: "Luminary",
    },
    {
      scoreThreshold: 2500,
      imgSrc: Achivement10,
      alt: "Achievement 10",
      title: "Beacon Of Medicine",
    },
  ];

  useEffect(() => {
    const fetchNewBadges = async () => {
      if (!achievements || achievements.length === 0 || UserScore == null) {
        console.warn("No achievements data or UserScore is not defined.");
        return;
      }

      try {
        // Get the titles of badges the user qualifies for based on UserScore
        const achievedBadgeTitles = achievements
          .filter((achievement) => UserScore >= achievement.scoreThreshold)
          .map((achievement) => achievement.title);

        // Check for newly achieved badges with the backend
        const response = await checkBadgesAward({
          current_user_badges: achievedBadgeTitles,
        }).unwrap();

        if (response?.showPopup) {
          // Show popup and add new badges to state if the backend confirms new awards
          setShowPopup(true);
          setNewBadges((prevBadges) => [...prevBadges, ...response.newBadges]);
        }
      } catch (error) {
        console.error("Error checking badge awards:", error);
      }
    };

    fetchNewBadges();
  }, [UserScore, checkBadgesAward]);
  const getBadgeData = (score) => {
    if (score >= 2500) {
      return {
        text: "The pinnacle of achievement! Your expertise lights the way for the future of healthcare.",
        imgSrc: Achivement10,
      };
    } else if (score >= 2000) {
      return {
        text: "A beacon of brilliance in the medical field, guiding others with your knowledge.",
        imgSrc: Achivement9,
      };
    } else if (score >= 1750) {
      return {
        text: "Casting spells of wisdom and healing with exceptional medical prowess.",
        imgSrc: Achivement8,
      };
    } else if (score >= 1500) {
      return {
        text: "Your dedication and skills are heroic, inspiring others to follow your lead.",
        imgSrc: Achivement7,
      };
    } else if (score >= 1250) {
      return {
        text: "You’re conquering challenges and standing strong in the fight against diseases.",
        imgSrc: Achivement6,
      };
    } else if (score >= 1000) {
      return {
        text: "Your expertise is taking off, showcasing advanced understanding in the field.",
        imgSrc: Achivement5,
      };
    } else if (score >= 500) {
      return {
        text: "Demonstrating mastery and growing into a true scholar of medicine.",
        imgSrc: Achivement4,
      };
    } else if (score >= 250) {
      return {
        text: "You’re building a solid foundation of medical knowledge. Keep striving for excellence!",
        imgSrc: Achivement3,
      };
    } else if (score >= 100) {
      return {
        text: "Gaining confidence and sharpening your skills. Keep the momentum going!",
        imgSrc: Achivement2,
      };
    } else if (score >= 50) {
      return {
        text: "Your journey begins! Step into the world of medical expertise with this first milestone.",
        imgSrc: Achivement1,
      };
    } else {
      return {
        text: "Keep going to unlock your first badge and start your journey in the world of medical expertise!",
        imgSrc: null,
      };
    }
  };

  const badgeData = getBadgeData(UserScore);
  return (
    <div className="tooltipextender">
      <BadgePopup
        isVisible={showPopup}
        togglePopup={togglePopup}
        text={badgeData.text}
        badgeimage={badgeData.imgSrc}
        score={UserScore}
        userIcon={userImage}
      />
      <div className="clinicalrow displayeverywhere clinicalrownolimits">
        {achievements.map((achievement, index) => (
          <React.Fragment key={index}>
            <div className="clinicalachievement">
              <img
                src={achievement.imgSrc}
                alt={achievement.alt}
                className={`${
                  UserScore >= achievement.scoreThreshold
                    ? "opacity-100 scale-125"
                    : "grayscale opacity-50"
                }`}
              />
              <div className="achievementtool">
                <div className="toptriangle"></div>
                <p>
                  {achievement.title}: {achievement.scoreThreshold}
                  {index < achievements.length - 1
                    ? ` to ${achievements[index + 1].scoreThreshold}`
                    : ""}
                </p>
              </div>
            </div>
            {index < achievements.length - 1 && (
              <div className="achievementgap">
                <img
                  src={GapLine}
                  alt="Gap Line"
                  className={
                    UserScore < achievements[index + 1].scoreThreshold
                      ? "grayscale"
                      : ""
                  }
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
